import React, {useContext} from "react";
import "./Footer.scss";
import {Fade} from "../reveal/Reveal";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="5px">
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {emoji("Made with React ⚛️")}
          <br />
          {emoji("© 2024-2026")}
        </p>
      </div>
    </Fade>
  );
}
